var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msgtypeLink"},[_c('a',{attrs:{"href":_vm.items.content.link_url,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.items.content.link_url)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }